import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Panel as Panel$1 } from 'primereact/panel';
import { useRef, useEffect } from 'react';
import { getHeaderTemplate } from './utils/HeaderTemplateTransformations.js';
import { getHeader } from './utils/HeaderTransformations.js';

function Panel(props) {
  const panelRef = useRef(null);
  const {
      className: classNameProps,
      toggleable,
      iconOnly: _,
      tooltip: __,
      headerClassName: headerClassNameProps,
      onlyContent,
      tertiary
    } = props,
    defaultProps = __rest(props, ["className", "toggleable", "iconOnly", "tooltip", "headerClassName", "onlyContent", "tertiary"]);
  const headerTemplate = getHeaderTemplate(props, panelRef);
  const header = getHeader(props);
  const panelClassName = clsx(classNameProps, toggleable === false ? 'toggle-disabled' : null, onlyContent ? 'content-only' : null, tertiary ? 'tertiary' : null);
  const headerClassName = clsx(headerClassNameProps);
  const setPanelHeight = () => {
    if (!panelRef.current) return;
    const panelElement = panelRef.current.getElement();
    if (!panelElement) return;
    const contentElement = panelElement.querySelector('.p-panel-content, .p-toggleable-content');
    if (contentElement) {
      const h = "".concat(contentElement.scrollHeight, "px");
      panelElement.style.setProperty('--panel-h', h);
    }
  };
  // Calculate and set initial height on mount
  useEffect(() => {
    // Set immediately
    setPanelHeight();
    // Also set after a short delay to catch any dynamic content
    const timer = setTimeout(setPanelHeight, 100);
    return () => clearTimeout(timer);
  }, []);
  const handleClick = e => {
    var _a, _b, _c;
    if (toggleable === false) {
      return;
    }
    const headerElement = (_b = (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.getElement()) === null || _b === void 0 ? void 0 : _b.firstElementChild;
    const contains = headerElement === null || headerElement === void 0 ? void 0 : headerElement.contains(e.target);
    if (contains) {
      (_c = panelRef.current) === null || _c === void 0 ? void 0 : _c.toggle(e);
    }
  };
  return jsx(Panel$1, Object.assign({
    ref: panelRef,
    pt: {
      header: {
        className: headerClassName
      }
    },
    className: panelClassName,
    headerTemplate: headerTemplate,
    expandIcon: "pi pi-chevron-down",
    collapseIcon: "pi pi-chevron-up",
    toggleable: toggleable === undefined ? true : toggleable,
    onClick: e => handleClick(e),
    transitionOptions: {
      classNames: {
        enter: 'panel-transition-enter',
        enterActive: 'panel-transition-enter--active',
        enterDone: 'panel-transition--done',
        exit: 'panel-transition-exit',
        exitActive: 'panel-transition-exit--active',
        exitDone: 'panel-transition--done'
      },
      onExit: () => setTimeout(setPanelHeight, 0),
      addEndListener: () => {}
    }
  }, defaultProps, {
    header: header
  }));
}

export { Panel };
